import script from "./contacts-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./contacts-modal.vue?vue&type=script&setup=true&lang=js"

import "./contacts-modal.vue?vue&type=style&index=0&id=23a0edfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a0edfd"]])

export default __exports__